<script setup lang="ts">
import { ref } from "vue";
import { Permission } from "../../../../../types/auth";
import { FilterField, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import ModalFormTemplate from '../../../../../components/ui/Templates/ModalFormTemplate.vue'
import StockTransfersForm from '../../../../inventory/inventorymanagement/stocktransfers/StockTransfersForm.vue';
import StockTransferReceiveForm from '../../../../inventory/inventorymanagement/stocktransfers/StockTransferReceiveForm.vue';

const endPoint = '/clients/inventory/inventory-management/stock-transfers/'
const title = 'Stock Transfers'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const showStockReceiveForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus' | string>('view')
const formReceiveMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus' | string>('view')
const refreshData = ref(false)

const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'date' },
  { name: 'ref_no', caption: 'Ref. No', sortable: true, fieldType: 'text'},
  { name: 'outlet', caption: 'Outlet', sortable: true, fieldType: 'text'},
  { name: 'from_warehouse', caption: 'From Warehouse', sortable: true, fieldType: 'text' },
  { name: 'to_warehouse', caption: 'To Warehouse', sortable: true, fieldType: 'text' },
  { name: 'transit_warehouse', caption: 'Transit Warehouse', sortable: true, fieldType: 'text' },
  { name: 'status', caption: 'Status', sortable: false, fieldType: 'text' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
    options: [
      { id: '1', name: 'Active' },
      { id: '0', name: 'Inactive' }
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleActions = (action: string, item: any) => {
  if (action == 'receive') {
    selectedData.value = item
    formReceiveMode.value = 'create'
    showStockReceiveForm.value = true
  }
}

const handleData = (data : any) => {
  selectedData.value = data
}

const listViewRef = ref<InstanceType<typeof ListTemplate> | null>(null);
const viewDocument = (data : any, title: string, path: string) => {
  if (listViewRef.value) {
    listViewRef.value.viewDocument(data, title, path);
  }
}

</script>

<template>
    <ModalFormTemplate
    mode="view" title="Sales Quotations" :endPoint="endPoint" :fullscreen="true"
    :tabList="[]" 
    @close="$emit('close')"
    >
    <template #form>
        <ListTemplate ref="listViewRef" :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[
    { name: 'receive', icon: 'Blocks', title: 'Receive Items', permission: 'Receive Stock', variant: 'primary', visible: (item) => item.status == 'Pending' },
  ]" :filterFields ="filterFields" :allow-disable="false" @custom="handleActions" :show-edit="false"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData">
  <template #form-view>
    <StockTransfersForm
      v-if="showForm"
      :permissions="permissions"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @view-document="viewDocument"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
    <StockTransferReceiveForm
      v-if="showStockReceiveForm"
      :permissions="permissions"
      :transfer="selectedData"
      end-point="/clients/inventory/inventory-management/stock-transfer-receipts/"
      title="Receive Items"
      :mode="formReceiveMode"
      @view-document="viewDocument"
      @save="refreshData = !refreshData"
      @close="showStockReceiveForm = false"
    />
  </template>
  </ListTemplate>
  </template>
  </ModalFormTemplate>


</template>
